import RibbonButton, { RibbonButtonState } from './RibbonButton';
import strings from 'owa-strings/owa-mail-strings';
import { toggleUnderline } from 'roosterjs-editor-api';

const underline: RibbonButton = {
    key: 'underline',
    title: () => strings.underline,
    imageSrc: require('../svg/underline.svg'),
    shortcutWin: 'Ctrl+U',
    shortcutMac: '⌘+U',
    buttonState: formatState =>
        formatState.isUnderline ? RibbonButtonState.Checked : RibbonButtonState.Normal,
    onExecute: plugin => toggleUnderline(plugin.getEditor()),
};

export default underline;
